/**
 * @desc 重盘任务
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inventoryMaster.reset.Params, options?: any) {
  return updateResponse(
    http(URL + `/inventoryMaster/reset`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
